<ng-template #iconTemplate>
  <mat-icon>
    <ng-content select="mat-icon">
    </ng-content>
  </mat-icon>
</ng-template>

@if (!asIcon) {
  <button (click)="clicked.emit()" [disabled]="disabled" class="text-button" color="primary" mat-button>
    <mat-label>
      <ng-content select="mat-label">
      </ng-content>
    </mat-label>
    <span class="custom-chips">{{ count }}</span>
  </button>
}

@if (asIcon) {
  <button (click)="clicked.emit()" [disabled]="disabled" [appBadge]="!withoutBadge && count"
    color="primary"
    mat-icon-button>
    <ng-container [ngTemplateOutlet]="iconTemplate">
    </ng-container>
  </button>
}
